import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    // Automatically open the modal by setting the frame's src
    const modalFrame = document.getElementById("modal")
    if (modalFrame && this.urlValue) {
      modalFrame.src = this.urlValue
    }
  }
}
